export class WebZoneConfig {
    realName: string
}